import project01 from "../img/projects/01.PNG"; // add right image
import project02 from "../img/projects/02.PNG";
import project03 from "../img/projects/03.PNG";
// import project04 from "../img/projects/04.jpg";
// import project05 from "../img/projects/05.jpg";
// import project06 from "../img/projects/06.jpg";
import project01Big from "../img/projects/01-big.PNG";
import project02Big from "../img/projects/02-big.PNG";
import project03Big from "../img/projects/03-big.PNG";
// import project04Big from "../img/projects/04-big.jpg";
// import project05Big from "../img/projects/05-big.jpg";
// import project06Big from "../img/projects/06-big.jpg";
// import project00 from "../img/projects/00.PNG";
// import project00Big from "../img/projects/00-big.PNG";

const projects = [
  // {
  //   title: "portfolio",
  //   img: project00,
  //   imgBig: project00Big,
  //   skills:
  //     "React, TypeScript, Redux toolkit, styled-components, Git, Netlify, Jira",
  //   link: "https://github.com/Igogoblin/se",
  //   deploy: "https://ivanshabanistan.netlify.app/contacts",
  // },
  {
    title: "TechLab - portal for IT courses",
    img: project01,
    imgBig: project01Big,
    skills:
      "React, TypeScript, Redux toolkit, styled-components, Git, Netlify, Jira",
    link: "https://github.com/Igogoblin/TechLab",
    deploy: "https://illustrious-gelato-478c12.netlify.app/",
  },
  {
    title: "Organizer - a simple app for composing everyday tasks",
    img: project02,
    imgBig: project02Big,
    skills: "Vite, React, Redux toolkit, styled-modules, Git",
    link: "https://github.com/Igogoblin/viteDeploy",
    deploy: "https://igogoblin.github.io/viteDeploy/",
  },
  {
    title: "Card game",
    img: project03,
    imgBig: project03Big,
    skills: "Vite, React, Redux toolkit, styled-modules, Git, Jira",
    link: "https://github.com/Igogoblin/pyramid",
    deploy: "https://igogoblin.github.io/pyramid/",
  },
  // {
  //   title: "Dating app",
  //   img: project04,
  //   imgBig: project04Big,
  //   skills: "React, Node.js, MongoDB",
  //   link: "https://github.com",
  // },
  // {
  //   title: "Landing",
  //   img: project05,
  //   imgBig: project05Big,
  //   skills: "React, Node.js, MongoDB",
  //   link: "https://github.com",
  // },
  // {
  //   title: "Gaming community",
  //   img: project06,
  //   imgBig: project06Big,
  //   skills: "React, Node.js, MongoDB",
  //   link: "https://github.com",
  // },
];

// export default projects;
export { projects };
